// Regole di squadra, identiche a quelle del server (backend/app/domain/rules.py).
// Prima erano reimplementate sei volte fra pagine e componenti, con formule che
// avevano gia iniziato a divergere.

import { ROLES } from './constants';

export function totalSlots(playersPerTeam) {
    return ROLES.reduce((sum, role) => sum + (playersPerTeam?.[role] ?? 0), 0);
}

export function rosterOf(team) {
    if (!team) return [];
    return team.roster ?? team.players ?? [];
}

export function roleCount(team, role) {
    return rosterOf(team).filter((entry) => entry.role === role).length;
}

export function remainingSlots(team, playersPerTeam) {
    return Math.max(0, totalSlots(playersPerTeam) - rosterOf(team).length);
}

/** Massimo spendibile ora, tenendo un credito per ogni altro slot da riempire. */
export function maxBid(team, playersPerTeam) {
    if (!team) return 0;
    const slots = remainingSlots(team, playersPerTeam);
    if (slots <= 0) return 0;
    return Math.max(0, team.budget - (slots - 1));
}

/** Il numero che serve davvero durante l'asta: crediti medi per slot residuo. */
export function creditsPerRemainingSlot(team, playersPerTeam) {
    if (!team) return 0;
    const slots = remainingSlots(team, playersPerTeam);
    if (slots <= 0) return 0;
    return team.budget / slots;
}

export function isRoleFull(team, role, playersPerTeam) {
    if (!team) return false;
    return roleCount(team, role) >= (playersPerTeam?.[role] ?? 0);
}

/**
 * Rimborso per lo svincolo. `inSerieA === false` significa uscito dalla Serie A
 * e quindi prezzo pieno; `null` significa lista quotazioni non disponibile, e
 * l'interfaccia deve dirlo invece di far finta di saperlo.
 */
export function refundAmount(purchasePrice, inSerieA) {
    if (inSerieA === false) return purchasePrice;
    return Math.ceil(purchasePrice / 2);
}

export function ownsPlayer(team, playerId) {
    return rosterOf(team).some((entry) => entry.player_id === playerId);
}

/** Insieme degli id gia assegnati a qualcuno, per filtrare la ricerca. */
export function assignedPlayerIds(teams) {
    const ids = new Set();
    Object.values(teams ?? {}).forEach((team) => {
        rosterOf(team).forEach((entry) => ids.add(entry.player_id));
    });
    return ids;
}

/** Ordina una rosa per ruolo (P, D, C, A) e poi per prezzo decrescente. */
export function sortRoster(roster) {
    const order = { P: 0, D: 1, C: 2, A: 3 };
    return [...(roster ?? [])].sort(
        (a, b) => order[a.role] - order[b.role] || b.purchase_price - a.purchase_price,
    );
}
